import * as React from 'react';
import styled from "@emotion/styled";
import {has} from 'lodash';
import {SKELETON_LOADER} from "../const";
const {SKELETON_LOADER_FG} = SKELETON_LOADER;

export const ButtonBase = styled.button`
  transition: all 200ms ease;
  cursor: pointer;
  
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  
  border: 1px solid;
  border-radius: ${({theme}) => !has(theme, 'thumbnailBorderRadius') ? '10' : theme.thumbnailBorderRadius}px;
  
  &:disabled {
    cursor: auto;
  }
`;

export const ErrorBase = styled.li`
  color: ${({theme}) => theme.errorColor};
  align-items: center;

  div > div,
  svg {
    width: inherit;
    height: inherit;
    fill: inherit;
  }
`;

export const Figure = styled('figure')`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  align-content: center;
  height: 100%;
  
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  
  > img,
  svg {
    color: inherit;
    align-self: center;
    object-fit: cover;
    width: 100%;
  }
  
  > img {
    position: absolute;
    min-height: 100%;
  }
  
  &.loading img {
    visibility: hidden;
    height: 0;
  }
  
  &.spotlight button.is-topic {
    background: rgba(0, 0, 0, 0.10);
  }

  &.spotlight:after {
    content: '';
    display: block;
    position: absolute;
    height: 100%;
    width: 100%;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 49.76%, #000000 100%);
  }
  
  &.spotlight.loading button {
    background: transparent;
  }

  &.spotlight.loading:after {
    display: none;
  }
`;

export const Caption = styled('figcaption')`
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  flex-flow: row nowrap;
  z-index: 0;
`;

export const InputBase = styled.input<{disabled?: boolean, errors?: string[]}>`
  // reset
  width: 100%;
  border: 0;
  color: inherit;
  font-family: inherit;
  font-weight: inherit;
  font-size: inherit;
  box-sizing: border-box;
  background-color: inherit;

  &::placeholder {
      color: ${({theme}) => theme.disabledFontColor};
      line-height: initial;
  }
  &::-ms-input-placeholder {
    color: ${({theme}) => theme.disabledFontColor};
  }   
 
  // pseudo-resets
  &[type='number'] {
    appearance: textfield;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      appearance: none;
      margin: 0;
    }
  }
  
  &::-ms-clear, &::-ms-reveal {
    display: none;
  }
`;

export const Textarea = styled.textarea<{disabled?: boolean, errors?: string[]}>`
  // reset
  color: inherit;
  font-family: inherit;
  font-weight: inherit;
  font-size: inherit;
  width: 100%;
  border: 0;
  box-sizing: border-box;
  background-color: inherit;

  &::placeholder {
      color: ${({theme}) => theme.disabledFontColor};
      line-height: initial;
  }
  &::-ms-input-placeholder {
    color: ${({theme}) => theme.disabledFontColor};
  }
`;

export const Separator = styled('i')`
  padding: 0 4px;

  :before {
    content: '•';
    position: relative;
    width: 6px;
    height: 6px;
    padding-top: 4px;
  }
`;

export const Tag = styled(ButtonBase)`
  width: 100%;
  border-style: solid;
  border-width: 1px;
  border-color: inherit;
  color: inherit;
  background-color: transparent;
  height: 1.25rem;
  cursor: pointer;
  padding: 0px 8px;
  position: relative;
  flex: 0;
  display: flex;
  align-items: center;

  > label {
    cursor: pointer;
    position: relative;
    font-weight: inherit;
    top: -0.5px;
  }

  &:disabled {
    color: ${SKELETON_LOADER_FG};
    cursor: default;
  }
`;

const SidebarStyled = styled('aside')`
  position: relative;
`;

interface Props {
  style: {
    [key: string]: string|number;
  }
}

export const Sidebar: React.FC<Props> = ({
  children,
  ...props
}) => (
  <SidebarStyled {...props}>
    {children}
  </SidebarStyled>
);

export const StickyContainer = styled('div')`
  position: sticky;
  top: 0;
`;

export const Widget = styled('section')`
  display: flex;
  min-height: 138px;
`;
